import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';

const ButtonDisable = ({ funcion, data, disabled }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip>Deshabilitar</Tooltip>}
    >
      <span>
        <IconButton
          buttonSize="sm"
          style={{ width: 30 }}
          icon="fa-pause"
          onClick={
            !disabled ? (data ? () => funcion(data) : funcion) : () => {}
          }
          variant="light"
          className="px-2"
          disabled={disabled}
        />
      </span>
    </OverlayTrigger>
  );
};

ButtonDisable.propTypes = {
  funcion: PropTypes.func.isRequired,
  data: PropTypes.any,
  disabled: PropTypes.bool
};

export default ButtonDisable;
